import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconRules = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 3C16.6193 3 15.5 4.11929 15.5 5.5C15.5 6.88071 16.6193 8 18 8C19.3807 8 20.5 6.88071 20.5 5.5C20.5 4.11929 19.3807 3 18 3ZM6 4.5H4C3.44772 4.5 3 4.94772 3 5.5C3 6.05228 3.44772 6.5 4 6.5H6C6.55228 6.5 7 6.05228 7 5.5C7 4.94772 6.55228 4.5 6 4.5ZM12 4.5H10C9.44772 4.5 9 4.94772 9 5.5C9 6.05228 9.44772 6.5 10 6.5H12C12.5523 6.5 13 6.05228 13 5.5C13 4.94772 12.5523 4.5 12 4.5ZM17 19.5V17.5C17 16.9477 17.4477 16.5 18 16.5C18.5523 16.5 19 16.9477 19 17.5V19.5C19 20.0523 18.5523 20.5 18 20.5C17.4477 20.5 17 20.0523 17 19.5ZM17 11.5V13.5C17 14.0523 17.4477 14.5 18 14.5C18.5523 14.5 19 14.0523 19 13.5V11.5C19 10.9477 18.5523 10.5 18 10.5C17.4477 10.5 17 10.9477 17 11.5Z"
        />
      </svg>
    );
  }
);
